import { createFileRoute, Navigate, useLocation } from '@tanstack/react-router';
import { OtpWrapper, UserPasswordForm } from '@amber-ui/core';

function OtpResetPassword() {
  const { searchStr } = useLocation();
  const searchParams = new URLSearchParams(searchStr);
  const otp = searchParams.get('otp');
  if (!otp) return <Navigate to="/otp/error" replace />;
  return (
    <OtpWrapper token={otp}>
      <UserPasswordForm token={otp} user_id={null} />
    </OtpWrapper>
  );
}

export const Route = createFileRoute('/otp/reset_password')({
  component: OtpResetPassword,
});
